import React, { memo, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Loader from "../../../components/Loader/Loader";
import { getAgencyTags } from "../../../services/apis";
import { toast } from "react-toastify";
import DynamicTable from "../../../components/Tables";

const Tags = () => {
  const [response, setResponse] = useState({
    tagsConfigured: [],
    tagsRemaining: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const configuredTags = [
    {
      title: "SL NO",
      isSortable: true,
      render: (_, index) => index + 1,
    },
    {
      id: "tagID",
      title: "Tag ID",
      key: "tagID",
      iskey: true,
      isSortable: true,
      render: (value) => value,
    },
  ];

  const unConfiguredTags = [
    {
      title: "SL NO",
      isSortable: true,
      iskey: true,
      render: (_, index) => index + 1,
    },
    {
      id: "tagID",
      title: "Tag ID",
      key: "tagID",
      iskey: true,
      isSortable: true,
      render: (value) => value,
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    getAgencyTags()
      .then((data) => {
        if (data?.statuscode) {
          const { tagsConfigured, tagsRemaining } = data?.data;

          const configuredTagsData = tagsConfigured.map(tag => ({ tagID: tag }));
          const remainingTagsData = tagsRemaining.map(tag => ({ tagID: tag }));

          setResponse({ tagsConfigured: configuredTagsData, tagsRemaining: remainingTagsData });
          setIsLoading(false);
        } else {
          toast.dismiss();
toast.error("Something went wrong!");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.dismiss();
toast.error("Error fetching data!");
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="w-full p-0 my-5">
      <h2 className="mb-4">Tags List</h2>
      <Row>
        <Col md={6} className="mb-4 mb-md-0">
          <div className="card bg-white p-4">
            <h4>Configured Tags</h4>
            <div>
              {!isLoading ? (
                <DynamicTable
                  cols={configuredTags}
                  response={response?.tagsConfigured || []}
                  isPaginate={true}
                  numberOfData={5}
                  headerClass="table-header"
                  rowHover={true}
                  fixedHeight={false}
                  isBgTransparent={false}
                  hideHeader={false}
                  isloading={isLoading}
                />
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </Col>

        <Col md={6}>
          <div className="card bg-white p-4">
            <h4>Unconfigured Tags</h4>
            <div>
              {!isLoading ? (
                <DynamicTable
                  cols={unConfiguredTags}
                  response={response?.tagsRemaining || []}
                  isPaginate={false}
                  numberOfData={5}
                  headerClass="table-header"
                  rowHover={true}
                  fixedHeight={false}
                  isBgTransparent={false}
                  hideHeader={false}
                  isloading={isLoading}
                />
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default memo(Tags);
